import { useState } from "react";
import PropTypes from 'prop-types';
import { useTrackedState } from "../../../../store";
import { FiltroFechas } from "../../../../utilities/gestion_fechas/FiltrosFechas";
import Paginacion from "../../../globales/Paginacion";

/**
 * Renderizara una tabla con las estadísticas de todas las sesiones de lecturas realizadas por un estudiante, estas estadísticas son pasadas de padre a hijo por props. 
 */
const TablaSesiones = (props) => {
  const { datos, textosTabla } = props;
  const { tabla, resultados } = textosTabla;
  const { fecha, sesiones, tiempo_promedio, libros_leidos, no_hay } = tabla;
  const { hay, resultado } = resultados;
  const state = useTrackedState();

  const [datosDivididos, setDatosDivididos] = useState([]);
  const ActualizarDatosDivididos = (value) => setDatosDivididos(value)

  return (
    <>
      <div role="table" aria-rowcount={datos.length} className={`${datos.length > 10 ? null : 'mb-5'}`}>
        <div role="rowgroup">
          <div role="row" className="encabezadoTabla  xl:grid grid-cols-12 ">
            <p role="columnheader" className="col-span-2 alineado-verticalmente">{fecha}</p>
            <p role="columnheader" className="col-span-3 center text-center">{sesiones}</p>
            <p role="columnheader" className="col-span-3 center text-center">{libros_leidos}</p>
            <p role="columnheader" className="col-span-4 center text-center">{tiempo_promedio}</p>
          </div>
        </div>

        <div role="rowgroup">
          {datosDivididos.length === 0 ?
            <div role="row" className="filaTabla xl:grid-cols-12">
              <div role="cell" className=" center col-span-12">
                <span className="icon-alerta text-18 red-inv-var2--color mr-3"></span>
                <p className="raleway-700 red-inv-var2--color text-13">{no_hay}</p>
              </div>
            </div>
            :
            datosDivididos.map((dato, i) => {
              return (
                <div role="row" key={`campo-${i}`} className="filaTabla xl:grid-cols-12">
                  <div role="cell" className="fila-12-sm3-lg6 xl:col-span-2">
                    <span role="columnheader" className="q7-14-negro26  xl:hidden">{fecha}</span>
                    <p className="raleway-700 primary-inv-var2--color text-13  una-linea-texto">{FiltroFechas.formatoUsuario(state?.idioma, dato.fecha) || 'N/A'}</p>
                  </div>
                  <div role="cell" className="fila-12-sm3-lg6 xl:col-span-3 overflow-auto">
                    <span role="columnheader" className="q7-14-negro26  xl:hidden">{sesiones}</span>
                    <p className={`r7-13-rojo una-linea-texto xl:text-center `} >{dato.numeroSesiones || 0}</p>
                  </div>
                  <div role="cell" className="fila-12-sm3-lg6 xl:col-span-3">
                    <span role="columnheader" className="q7-14-negro26  xl:hidden">{libros_leidos}</span>
                    <p className={`r7-13-rojo una-linea-texto xl:text-center`} >{dato.librosLeidos || 0}</p>
                  </div>
                  <div role="cell" className="fila-12-sm3-lg6 xl:col-span-4">
                    <span role="columnheader" className="q7-14-negro26  xl:hidden una-linea-texto">{tiempo_promedio}</span>
                    <p className={`r7-13-rojo una-linea-texto xl:text-center`} >{dato.tiempoPromedioEnPlataforma || 0} min</p>
                  </div>

                </div>
              )
            })
          }
        </div>
        <div className="md:alineado-verticalmente xl:mt-3">
          <div className={`w-full md:w-6/12 `}>
            <p className="r4-16-negro4A">{hay} {datos.length} {datos.length !== 1 ? resultado.plural : resultado.singular} </p>
          </div>

          <div className={`w-full md:w-6/12 alineado-izquierda mt-5 md:mt-0`}>
            <Paginacion datos={datos} datosDivididos={ActualizarDatosDivididos} />
          </div>
        </div>

      </div>
    </>
  )
}
export default TablaSesiones;


TablaSesiones.propTypes = {
  /**
    * Arreglo de objetos con los datos de la tabla
    */
  datos: PropTypes.arrayOf(PropTypes.shape({
    fecha: PropTypes.string,
    librosLeidos: PropTypes.number,
    numeroSesiones: PropTypes.number,
    tiempoPromedioEnPlataforma: PropTypes.number,
    tiempoPromedioLectura: PropTypes.number,
  })).isRequired,
  /**
   * Objeto con las traducciones de encabezado y boton
   * @type{
  * tabla: object
  * resultados: object
   * }
   */
  textosTabla: PropTypes.object.isRequired,
}